import Popover from 'trunks/vue/admin/components/libs/popover.js';
import { newAlertify } from 'trunks/vue/admin/components/alert.js';

export default Vue.extend({
  components: {
    Popover,
  },

  props: {
    access: {
      type: Object,
    },
  },

  template: `
    <Popover position='bottom center' :customClass='"confirm table-operation-confirm-popover delete-confirm-popover"' ref="deleteUserconfirmPopoverRef">
      <template slot='trigger'>
        <span class="operation-cell btn-text error-text">删除</span>
      </template>
      <template slot='content'>
        <div class="popover-confirm-content">
          <div class="popover-confirm-title">确认删除成员</div>
          <div class="popover-confirm-footer">
            <span class="btn btn-small btn-default outlined" @click.stop="close">取消</span>
            <span class="btn btn-small btn-danger" @click.stop="deleteMember">删除</span>
          </div>
        </div>
      </template>
    </Popover>
  `,

  methods: {
    deleteMember() {
      Skylark.Libs.Ajax.delete(`/admin/accesses/${this.access.id}`, {
        contentType: 'application/json; charset=utf-8',
        responseType: 'json',
        success: () => {
          newAlertify('删除成功', {
            type: 'success',
          });
          this.$emit('deleteMemberSuccessed', this.access);
        },
        error() {
          newAlertify('删除失败', {
            type: 'error',
          });
        },
        complete: () => {
          this.close();
        },
      });
    },

    close() {
      this.$refs.deleteUserconfirmPopoverRef.close();
    },
  },
});
